@if (isLoading) {
  <div id="preloader">
    <div id="loader"></div>
    @if (isImageUpload) {
      <p class="text-white text-center loader__text-waiting">
        Estamos guardando la imagen. <br />
        Esto puede tardar unos minutos
      </p>
    }
  </div>
}
